import actionTypes from '../constants/actionTypes'

export default function newsReducer(state = {}, action) {
  switch(action.type) {
    case actionTypes.GET_HEADLINES:
      var edition = action.edition || {}
      return Object.assign({}, state, {
        items : action.data.newsItems,
        heading: edition.isEspnCricinfo ? 'ESPNcricinfo headlines' :'ESPN.in Headlines'
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/news.js